var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"btn-twitter",attrs:{"block":""},on:{"click":function($event){return _vm.initAssign()}}},[_vm._v(" "+_vm._s(_vm.deliveryLogistic ? _vm.deliveryLogistic.toUpperCase() : 'Assign Logistic')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }